import { JourneySubTypeValues } from "#/components/carrot-card-cost-share/steps/shared/stepOptionValues"
import { WhatKindMenopauseStep } from "#/components/carrot-card-cost-share/steps/views/WhatKindMenopauseStep"
import { WhoWillReceiveCareStep } from "#/components/carrot-card-cost-share/steps/views/WhoWillReceiveCareStep"
import { GeneralSteps, MenopauseSteps, SectionName } from "#/components/carrot-card-cost-share/workflows/step-library"
import { PleaseConfirmTwoThingsStep } from "#/components/carrot-card-cost-share/steps/views/PleaseConfirmTwoThingsStep"
import { CarrotCardCantBeUsedStep } from "#/components/carrot-card-cost-share/steps/views/CarrotCardCantBeUsedStep"
import { ExpenseNotCoveredStep } from "#/components/carrot-card-cost-share/steps/views/ExpenseNotCoveredStep"

export enum Workflows {
  MENOPAUSE = "Menopause"
}

export const menopauseSteps = [
  { name: MenopauseSteps.WHO_WILL_RECEIVE_CARE_MENOPAUSE, component: WhoWillReceiveCareStep },
  { name: MenopauseSteps.WHAT_KIND_MENOPAUSE_EXPENSE, component: WhatKindMenopauseStep },
  { name: MenopauseSteps.CARROT_CARD_CANT_BE_USED, component: CarrotCardCantBeUsedStep },
  { name: MenopauseSteps.PLEASE_CONFIRM_TWO_THINGS, component: PleaseConfirmTwoThingsStep },
  { name: MenopauseSteps.EXPENSE_NOT_COVERED_MENOPAUSE, component: ExpenseNotCoveredStep }
]

//prettier-ignore
const menopauseFlow: MenopauseFlowTransition[] = [
  { at: MenopauseSteps.WHO_WILL_RECEIVE_CARE_MENOPAUSE, given: "ELIGIBLE",                             goto: MenopauseSteps.WHAT_KIND_MENOPAUSE_EXPENSE },
  { at: MenopauseSteps.WHO_WILL_RECEIVE_CARE_MENOPAUSE, given: "INELIGIBLE",                           goto: MenopauseSteps.EXPENSE_NOT_COVERED_MENOPAUSE },
  { at: MenopauseSteps.WHAT_KIND_MENOPAUSE_EXPENSE,     given: JourneySubTypeValues.TEMP_REG_PRODUCTS,      goto: MenopauseSteps.CARROT_CARD_CANT_BE_USED },
  { at: MenopauseSteps.WHAT_KIND_MENOPAUSE_EXPENSE,     given: JourneySubTypeValues.PELVIC_FLOOR_THERAPY,  goto: MenopauseSteps.CARROT_CARD_CANT_BE_USED },
  { at: MenopauseSteps.WHAT_KIND_MENOPAUSE_EXPENSE,     given: "",                                         goto: MenopauseSteps.PLEASE_CONFIRM_TWO_THINGS },
  { at: MenopauseSteps.CARROT_CARD_CANT_BE_USED,        given: "",                                         end: true },
  { at: MenopauseSteps.PLEASE_CONFIRM_TWO_THINGS,       given: "",                                     goto: GeneralSteps.TOTAL_COST, sectionName: SectionName.GENERAL },
  { at: MenopauseSteps.EXPENSE_NOT_COVERED_MENOPAUSE,   given: "",                                     end: true }
]

type MenopauseFlowTransition =
  | { at: MenopauseSteps; given: string; goto: MenopauseSteps; sectionName?: undefined }
  | { at: MenopauseSteps; given: string; goto: GeneralSteps; sectionName: string }
  | { at: MenopauseSteps; given: string; end: true }

export const menopauseWorkflows = [{ name: Workflows.MENOPAUSE, workflow: menopauseFlow }]
